import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Button } from '@wordpress/components';
import { decodeEntities } from '@wordpress/html-entities';
/**
 * Internal dependencies
 */

import BlockRatings from '../block-ratings';
import DownloadableBlockIcon from '../downloadable-block-icon';

function DownloadableBlockHeader(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      rating = _ref.rating,
      ratingCount = _ref.ratingCount,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$isInstallable = _ref.isInstallable,
      isInstallable = _ref$isInstallable === void 0 ? true : _ref$isInstallable,
      _onClick = _ref.onClick;
  return createElement("div", {
    className: "block-directory-downloadable-block-header__row"
  }, createElement(DownloadableBlockIcon, {
    icon: icon,
    title: title
  }), createElement("div", {
    className: "block-directory-downloadable-block-header__column"
  }, createElement("h2", {
    className: "block-directory-downloadable-block-header__title"
  }, decodeEntities(title)), createElement(BlockRatings, {
    rating: rating,
    ratingCount: ratingCount
  })), createElement(Button, {
    isSecondary: true,
    isBusy: isLoading,
    disabled: isLoading || !isInstallable,
    onClick: function onClick(event) {
      event.preventDefault();

      if (!isLoading && isInstallable) {
        _onClick();
      }
    }
  }, isLoading ? __('Adding…') : __('Add block')));
}

export default DownloadableBlockHeader;
//# sourceMappingURL=index.js.map